window.addEventListener('load', function() {
  function applyCustomStyles() {
    var style = document.createElement('style');
    style.innerHTML = `
      .pr-reviewsnippet, .pr-reviewdisplay, .pr-irlsnippet {
        max-width: 100% !important;
        margin: 0 auto !important;
        text-align: center !important;
      }

      .pr-stars, .pr-rating-count {
        display: inline-block !important;
        font-size: 1.2em !important;
      }

      @media (max-width: 768px) {
        .pr-stars, .pr-rating-count {
          font-size: 1em !important;
        }
      }

      @media (max-width: 480px) {
        .pr-stars, .pr-rating-count {
          font-size: 0.8em !important;
        }
      }

      /* Additional styles to ensure the container is flexible */
      .product-card {
        display: flex;
        flex-direction: column;
        height: auto !important;
        overflow: visible !important;
      }

      .product-card .product-featured-image,
      .product-card .product-card-info {
        flex: 1 1 auto;
        height: auto !important;
        overflow: visible !important;
      }
    `;
    document.head.appendChild(style);
  }

  function forceRepaint() {
    var evt = window.document.createEvent('UIEvents'); 
    evt.initUIEvent('resize', true, false, window, 0); 
    window.dispatchEvent(evt);
  }

  // Apply styles immediately after the full load
  applyCustomStyles();
  forceRepaint();

  // Reapply styles and force repaint after PowerReviews are rendered
  document.addEventListener('PowerReviewsLoaded', function() {
    applyCustomStyles();
    forceRepaint();
  }, false);
});

(function () {
  var STORAGE_KEY = 'moPreferredShowroom';
  var stores = {
    'nicholasville-road': {
      label: 'Lexington / Nicholasville Road',
      shortLabel: 'Lexington',
      url: '/pages/mattress-overstock-nicholasville-road',
      lat: 37.9778749,
      lon: -84.529193,
      aliases: ['mattress-overstock-nicholasville-road', 'mattress-overstock-lexington-ky']
    },
    richmond: {
      label: 'Richmond',
      shortLabel: 'Richmond',
      url: '/pages/mattress-overstock-richmond-ky',
      lat: 37.7361924,
      lon: -84.3064799,
      aliases: ['mattress-overstock-richmond-ky']
    },
    georgetown: {
      label: 'Georgetown',
      shortLabel: 'Georgetown',
      url: '/pages/mattress-overstock-georgetown-ky',
      lat: 38.1894016,
      lon: -84.5622319,
      aliases: ['mattress-overstock-georgetown-ky']
    },
    london: {
      label: 'London',
      shortLabel: 'London',
      url: '/pages/mattress-overstock-london-ky',
      lat: 37.1119026,
      lon: -84.0658445,
      aliases: ['mattress-overstock-london-ky']
    },
    somerset: {
      label: 'Somerset',
      shortLabel: 'Somerset',
      url: '/pages/mattress-overstock-somerset-ky',
      lat: 37.05,
      lon: -84.629,
      aliases: ['mattress-overstock-somerset-ky']
    }
  };
  var aliasToKey = {};
  Object.keys(stores).forEach(function (key) {
    aliasToKey[key] = key;
    stores[key].aliases.forEach(function (alias) {
      aliasToKey[alias] = key;
    });
  });
  function parseKeys(value) {
    if (!value) return [];
    return value.split(',').map(function (key) { return key.trim(); }).filter(function (key) { return stores[key]; });
  }
  function keyFromValue(value) {
    if (!value) return '';
    return aliasToKey[String(value).trim().toLowerCase()] || '';
  }
  function keyFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var paramKey = keyFromValue(params.get('mo_showroom') || params.get('showroom') || params.get('store'));
    if (paramKey) return paramKey;
    var handle = window.location.pathname.split('/').filter(Boolean).pop();
    return keyFromValue(handle);
  }
  function storedKey() {
    try {
      return keyFromValue(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return '';
    }
  }
  function saveKey(key) {
    try {
      window.localStorage.setItem(STORAGE_KEY, key);
    } catch (error) {}
  }
  function distanceMiles(aLat, aLon, bLat, bLon) {
    var r = 3958.8;
    var toRad = Math.PI / 180;
    var dLat = (bLat - aLat) * toRad;
    var dLon = (bLon - aLon) * toRad;
    var lat1 = aLat * toRad;
    var lat2 = bLat * toRad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * r * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  }
  function nearestFromPoint(lat, lon, candidateKeys) {
    var bestKey = '';
    var bestDistance = Infinity;
    candidateKeys.forEach(function (key) {
      var store = stores[key];
      if (!store) return;
      var miles = distanceMiles(lat, lon, store.lat, store.lon);
      if (miles < bestDistance) {
        bestDistance = miles;
        bestKey = key;
      }
    });
    return bestKey;
  }
  function nearestFromStore(selectedKey, candidateKeys) {
    if (!candidateKeys.length) return '';
    if (selectedKey && candidateKeys.indexOf(selectedKey) !== -1) return selectedKey;
    var selected = stores[selectedKey];
    if (!selected) return candidateKeys[0];
    return nearestFromPoint(selected.lat, selected.lon, candidateKeys);
  }
  function preferredKey() {
    return keyFromUrl() || storedKey();
  }
  function updateCardBadges(selectedKey) {
    document.querySelectorAll('[data-mo-card-tryability]').forEach(function (badge) {
      var label = badge.querySelector('[data-mo-card-tryability-label]');
      if (!label) return;
      var kind = badge.getAttribute('data-mo-card-tryability');
      var candidateKeys = parseKeys(badge.getAttribute('data-mo-showroom-keys'));
      var nearestKey = nearestFromStore(selectedKey, candidateKeys);
      var store = stores[nearestKey];
      if (!store) return;
      badge.href = store.url;
      badge.setAttribute('data-mo-selected-showroom', nearestKey);
      if (kind === 'exact') {
        label.textContent = 'Try in ' + store.shortLabel;
      } else if (kind === 'similar') {
        label.textContent = 'Compare similar feel in ' + store.shortLabel;
      } else if (kind === 'confirm') {
        label.textContent = 'Ask ' + store.shortLabel + ' about floor display';
      }
    });
  }
  function updatePreferenceBars(selectedKey) {
    var store = stores[selectedKey];
    if (!store) return;
    document.querySelectorAll('[data-mo-showroom-preference-bar]').forEach(function (bar) {
      var status = bar.querySelector('[data-mo-showroom-preference-status]');
      if (status) status.textContent = 'Using ' + store.label + ' for try-in notes on this collection.';
      bar.querySelectorAll('[data-mo-location-choice]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-mo-location-choice') === selectedKey ? 'true' : 'false');
      });
    });
  }
  function updatePdpModules(selectedKey) {
    document.querySelectorAll('[data-mo-tryability]').forEach(function (module) {
      var exactKeys = parseKeys(module.getAttribute('data-mo-exact-showroom-keys'));
      var similarKeys = parseKeys(module.getAttribute('data-mo-similar-showroom-keys'));
      var confirmKeys = parseKeys(module.getAttribute('data-mo-confirm-showroom-keys'));
      var status = 'exact';
      var candidateKeys = exactKeys;
      if (!candidateKeys.length) {
        status = 'similar';
        candidateKeys = similarKeys;
      }
      if (!candidateKeys.length) {
        status = 'confirm';
        candidateKeys = confirmKeys;
      }
      var nearestKey = nearestFromStore(selectedKey, candidateKeys);
      var store = stores[nearestKey];
      if (!store) return;
      var title = module.querySelector('[data-mo-tryability-title]');
      var body = module.querySelector('[data-mo-tryability-body]');
      var nearest = module.querySelector('[data-mo-tryability-nearest]');
      var nearestTitle = module.querySelector('[data-mo-tryability-nearest-title]');
      var nearestBody = module.querySelector('[data-mo-tryability-nearest-body]');
      var nearestLink = module.querySelector('[data-mo-tryability-nearest-link]');
      if (status === 'exact') {
        if (title) title.textContent = 'Try this mattress in ' + store.shortLabel;
        if (body) body.textContent = 'This model is marked for exact floor display at the ' + store.shortLabel + ' showroom. You can still compare the other marked locations below.';
        if (nearestTitle) nearestTitle.textContent = 'Closest exact display: ' + store.label;
        if (nearestBody) nearestBody.textContent = 'Start with this showroom, then call ahead if you are driving in for one exact model.';
      } else if (status === 'similar') {
        if (title) title.textContent = 'Compare a similar feel in ' + store.shortLabel;
        if (body) body.textContent = 'The ' + store.shortLabel + ' team can help compare the closest available feel and confirm the floor setup.';
        if (nearestTitle) nearestTitle.textContent = 'Closest similar-feel help: ' + store.label;
        if (nearestBody) nearestBody.textContent = 'Use the showroom team to narrow pressure, cooling, motion, height, and base fit.';
      } else {
        if (title) title.textContent = 'Ask ' + store.shortLabel + ' before you drive in';
        if (body) body.textContent = 'The showroom team can confirm the floor setup and point you toward the closest comparable feel.';
        if (nearestTitle) nearestTitle.textContent = 'Closest showroom: ' + store.label;
        if (nearestBody) nearestBody.textContent = 'Call or visit the showroom page before planning the trip around one exact model.';
      }
      if (nearestLink) nearestLink.href = store.url;
      if (nearest) nearest.hidden = false;
      module.querySelectorAll('[data-showroom-key]').forEach(function (card) {
        var isNearest = card.getAttribute('data-showroom-key') === nearestKey;
        card.classList.toggle('is-mo-nearest', isNearest);
        if (isNearest && card.parentElement) {
          card.parentElement.insertBefore(card, card.parentElement.firstElementChild);
        }
      });
      module.querySelectorAll('[data-mo-location-choice]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-mo-location-choice') === nearestKey ? 'true' : 'false');
      });
    });
  }
  var reapplyTimer = null;
  function applySelectedShowroom(key) {
    if (!key || !stores[key]) return;
    document.documentElement.setAttribute('data-mo-selected-showroom', key);
    updateCardBadges(key);
    updatePreferenceBars(key);
    updatePdpModules(key);
  }
  function scheduleApply() {
    if (reapplyTimer) window.clearTimeout(reapplyTimer);
    reapplyTimer = window.setTimeout(function () {
      applySelectedShowroom(preferredKey());
    }, 80);
  }
  function bindInteractions() {
    document.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-mo-location-choice]');
      if (choice) {
        var key = keyFromValue(choice.getAttribute('data-mo-location-choice'));
        if (key) {
          event.preventDefault();
          saveKey(key);
          applySelectedShowroom(key);
        }
      }
      var geo = event.target.closest('[data-mo-location-geo]');
      if (geo) {
        event.preventDefault();
        if (!navigator.geolocation) {
          geo.textContent = 'Choose a showroom below';
          return;
        }
        geo.textContent = 'Finding nearest showroom';
        navigator.geolocation.getCurrentPosition(function (position) {
          var key = nearestFromPoint(position.coords.latitude, position.coords.longitude, Object.keys(stores));
          if (key) {
            saveKey(key);
            applySelectedShowroom(key);
            geo.textContent = 'Using ' + stores[key].shortLabel;
          }
        }, function () {
          geo.textContent = 'Choose a showroom below';
        }, { maximumAge: 300000, timeout: 8000, enableHighAccuracy: false });
      }
    });
  }
  function init() {
    bindInteractions();
    var urlKey = keyFromUrl();
    if (urlKey) saveKey(urlKey);
    applySelectedShowroom(preferredKey());
    if ('MutationObserver' in window && document.body) {
      new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
